import { george, i18n, pr, theme } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { IconSavings, LightSeparatorLine } from "components/util/primitives";
import { ui } from "components/util/uiHelpers";
import { config } from "config";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { BSPOptionsRoutes } from "./BSPOptionsRoutes";
import { BSPOptionsStore } from "./BSPOptionsStore";
import { BSPOptionsAppointmentCard } from "./components/BSPOptionsAppointmentCard";
import { getDefaultKeyPressHandler } from "util/helpers";

type IProps = RouteComponentProps<{ id: string }> & i18n.InjectedIntlProps & {
    store: BSPOptionsStore;
};

export const BSPOptionsDetails = observer(({ store }: IProps) => {
    const [didAutofocus, setDidAutofocus] = React.useState(false);
    const ref = React.useRef<HTMLAnchorElement | null>(null);

    React.useEffect(() => {
        if (ref.current && !didAutofocus) {
            ref.current.focus();
            setDidAutofocus(true);
        }
    }, []);

    const BackgroundComponent = externalInterfaceStore.isGeorgeApp ? george.Background : george.BackgroundWithNavBar;

    const handleClickProlongate = () => {
        pushRoute(BSPOptionsRoutes.SUMMARY);
    };

    const handleBack = async () => {
        pushRoute(BSPOptionsRoutes.ROOT);
    };

    if (store.isLoading) {
        return (
            <BackgroundComponent>
                <george.LoadingIndicator isLoading={store.isLoading} height={ui.windowHeight} />
            </BackgroundComponent>
        );
    }

    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const details = {
        contractNumber: store.buildingsAccount?.id,
        endDate: moment(store.prolongationDetails?.endDate).format("DD.MM.YYYY"),
        percent: store.prolongationDetails?.interestRate
    };

    return (
        <BackgroundComponent style={{ paddingTop: 24, paddingBottom: theme.MARGIN }}>
            <div style={pr.STYLE_CENTERED_CARD}>
                <a
                    ref={ref}
                    style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", flexGrow: 1, flexBasis: 0 }}
                    role="button"
                    tabIndex={0}
                    onClick={handleBack}
                    onKeyPress={getDefaultKeyPressHandler(handleBack)}
                    aria-label={ui.__("a11y.backToOverview")}
                >
                    <pr.IconChevronLeft className="theme-secondary-action-label-color" style={{ display: "block", flexShrink: 0 }} />
                    {!isMobile && (
                        <pr.P_16_CONTENT className="theme-secondary-action-label-color" style={{ fontWeight: 600 }}>
                            {ui.__("common.backToOverview")}
                        </pr.P_16_CONTENT>
                    )}
                </a>
            </div>
            <george.Card
                disableTopSpacing
                style={{
                    marginTop: 16,
                    borderRadius: 8,
                    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)"
                }}
            >
                <div style={{ padding: 32 }}>
                    <IconSavings style={{ width: 32, height: 32, color: "#027455", padding: 16, borderRadius: 32, backgroundColor: "#F2F9F7" }} />
                    <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", color: ui.isDarkMode ? "white" : "#0A285C", marginTop: 16 }}>
                        {store.selectedOption === "continueWithBonus" && ui.__("bspOptions.details.continueWithBonus.intro.title")}
                        {store.selectedOption === "continueWithBonusLegalGuardian" && ui.__("bspOptions.details.continueWithBonusLegalGuardian.intro.title")}
                    </pr.P_22_TITLE>
                    <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                        {store.selectedOption === "continueWithBonus" && ui.__("bspOptions.details.continueWithBonus.intro.text")}
                        {store.selectedOption === "continueWithBonusLegalGuardian" && ui.__("bspOptions.details.continueWithBonusLegalGuardian.intro.text")}
                    </pr.P_16_CONTENT>
                </div>
                <LightSeparatorLine />
                <div style={{ padding: 32 }}>
                    <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                        {store.selectedOption === "continueWithBonus" && ui.__("bspOptions.details.continueWithBonus.conditions.title")}
                        {store.selectedOption === "continueWithBonusLegalGuardian" && ui.__("bspOptions.details.continueWithBonusLegalGuardian.conditions.title")}
                    </pr.P_18_TITLE>
                    <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                        {store.selectedOption === "continueWithBonus" &&
                            ui.__(
                                "bspOptions.details.continueWithBonus.conditions.text",
                                { ...details, percent: details.percent?.replace(".", config.CURRENCY_DECIMAL_SEPARATOR) }
                            )
                        }
                        {store.selectedOption === "continueWithBonusLegalGuardian" &&
                            ui.__(
                                "bspOptions.details.continueWithBonusLegalGuardian.conditions.text",
                                { ...details, percent: details.percent?.replace(".", config.CURRENCY_DECIMAL_SEPARATOR) }
                            )
                        }
                    </pr.P_16_CONTENT>
                </div>
                <LightSeparatorLine />
                <div style={{ textAlign: "center", padding: 32 }}>
                    <GdsFakeActionButton color="primary" onClick={handleClickProlongate} fullWidth={isMobile}>
                        {ui.__("bspOptions.details.button")}
                    </GdsFakeActionButton>
                </div>
            </george.Card>
            {store.canBookAppointment && <BSPOptionsAppointmentCard isMobile={isMobile} style={{ marginTop: 32 }} />}
        </BackgroundComponent>
    );
});



// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsDetails.tsx